import React, { useEffect, useState,useRef } from 'react'
import Navber from './Navber.jsx'
import { useParams, useNavigate } from 'react-router-dom'
import api from "../Api.js";
import "../Styles/HotelDetails.css"
import img1 from "../Images/hotelimg.jpg"
import SafeComponent from './SafeComponent.jsx';
import MapWrapper from './Safemap.jsx';
import ImageOverlay from './ImageOverlay .jsx';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TextField, Button } from "@mui/material";
import dayjs from "dayjs";
import FullScreenSpin from "./Helping Component/Fullscreeenspinner.jsx"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import { showToast } from './PopupMessage.jsx';
import akashimg from "../Images/Akash Resume Pic.jpeg"
import humanImg from "../Images/human_icon.jpg"
import ImageLightbox from "../Components/Helping Component/ImageZoom.jsx";
import noimg from "../Images/noimg.jpg"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Position } from '@react-pdf-viewer/core';








function HotelDetails() {
  const [hotelDetails, setHotelDetails] = React.useState(null);
  const [hotelRooms, setHotelRooms] = React.useState([]);
  const [aminities, setAmenities] = React.useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [bookingID, setBookingID] = useState(null);
  const [roomID, setRoomID] = useState(null);
  const [roomImages, setRoomImages] = useState([]);
  const [infants, setInfants] = useState(0);
  const [children, setChildren] = useState(0);
  const [adults, setAdults] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [price, setPrice] = useState(0);
  const navigate = useNavigate();
  const [destination, setDestination] = useState("");
  const [checkIn, setCheckIn] = useState();
  const [checkOut, setCheckOut] = useState();
  const [availableRoom, setAvailableRoom] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hotelimg, setHotelimg] = useState([]);
  const [reviews, setReviews] = useState([]);
  const { id } = useParams();
  console.log("the id from hotel details is : ", id);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [showMealModal, setShowMealModal] = useState(false);
  const [roomsCount, setRoomsCount] = useState(1);
   const roomsRef = React.useRef(null);
   const InputDiv = React.useRef(null);


  const [mealCount, setMealCount] = useState({
    breakfast: 0,
    lunch: 0,
    dinner: 0,
  });


const scrollInput = () => {
  if(!InputDiv.current) return;
  InputDiv.current.scrollIntoView({ 
    top:0,
    behavior: 'smooth' });
};


  function formatTime(time) {
    if (!time) return "--:--"; // or return ""

    let [h, m] = time.split(":");
    h = Number(h);

    const period = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;

    return `${h}:${m} ${period}`;
  }

  function calculateNights(checkIn, checkOut) {
    const inDate = new Date(checkIn);
    const outDate = new Date(checkOut);

    // Difference in milliseconds
    const diffTime = outDate - inDate;

    // Convert ms → days
    const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return nights;
  }



  useEffect(() => {
    const fetchHotelDetails = async () => {
      try {
        setAccessToken(localStorage.getItem("accessTok") || null);
        const res = await api.get(`/hotels/${id}`);
        if (res.data.status === true) {
          setHotelDetails(res?.data?.data);
          setHotelimg(res?.data?.data?.image);
          setHotelRooms(res?.data?.data?.rooms || []);
          setRoomImages(res?.data?.data?.rooms?.images || []);
          setSelectedRoom(res?.data?.data?.rooms[0] || null);
          setAmenities(res?.data?.data?.amenities || []);
        }
      } catch (err) {
        console.log(err);
      }
    };

    const getReviews = async () => {
      try {
        const response = await api.get("/reviews");
        console.log("Reviews response:", response.data);
        if (response.data.status === true) {
          setReviews(response?.data?.data || []);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchHotelDetails();
    getReviews();
  }, [id]);

  console.log("reviews data:", reviews);
  const hotelreviews = hotelDetails
    ? reviews.filter(r => r.hotel_id === hotelDetails.id)
    : [];







  const handleSearch = () => {
    console.log("Search Clicked:", { destination, checkIn, checkOut });
  };
  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    const room = hotelRooms.find(r => r.id.toString() === roomId);
    setRoomID(roomId);
    if (room) {
      setSelectedRoom(room);
    }
  };


  useEffect(() => {
    if (!selectedRoom) return;
      // if(!accessToken){
      //   showToast("Please log in to continue booking.", "error");
      //   navigate('/signup');
      //   return;
      // }

    const {
      room_capacity,
      max_guests,
      price_per_night,
      adult_price,
      child_price
    } = selectedRoom;

    const totalGuests = adults + children;
    if(totalGuests > 1 || roomsCount> 1){
      if(!accessToken){
        showToast("Please log in to continue booking.", "error");
        navigate('/signup');
        return;
      }
    }

    // ❌ Max guest validation
    if (totalGuests > max_guests * roomsCount) {
      showToast(`Maximum Guest: ${max_guests}.please select multiple room`, "warning");
      return;
    }

    const basePrice = Number(price_per_night || 0);
    const extraAdultPrice = Number(adult_price || 0);
    const extraChildPrice = Number(child_price || 0);

    // ✅ If within room capacity → fixed price
    if (totalGuests <= room_capacity * roomsCount) {
      setTotalPrice(basePrice * roomsCount);
      return;
    }

    // ✅ Extra guests calculation
    let remainingExtra = totalGuests - room_capacity * roomsCount;

    // 🔹 Charge extra CHILDREN first
    const extraChildren = Math.min(remainingExtra, children);
    remainingExtra -= extraChildren;

    // 🔹 Remaining → extra ADULTS
    const extraAdults = remainingExtra;

    const total =
      basePrice * roomsCount +
      extraChildren * extraChildPrice +
      extraAdults * extraAdultPrice;

    setTotalPrice(total);

  }, [selectedRoom, adults, children, roomsCount]);

  const maxRooms = selectedRoom?.no_of_rooms || 1;



  const BookNow = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.", "warning");
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.", "warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests * roomsCount) {
      showToast(`The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`, "warning");
      return;
    }
    try {
      console.log("accessToken:", accessToken);
      if (!accessToken) {
        showToast("Please log in to book a room.", "warning");
        navigate('/signup');
        return;
      }
      // const now = new Date();
      // if (
      //   new Date(checkIn) < now ||
      //   new Date(checkOut) < now
      // ) {
      //   showToast("Check-in and Check-out must be in the future!", "warning");
      //   return;
      // }



      const nights = calculateNights(checkIn, checkOut);
      if (checkIn >= checkOut) {
        showToast("Please give right Date and Time...", "warning");
        return
      }

      const bookingData = {
        hotel_id: id,
        room_id: selectedRoom.id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),
        adults,
        children,
        infants,
        total_price:
          nights * roomTotalPrice + mealTotal * nights,
        no_of_rooms: roomsCount,
        meals: {
          breakfast_qty: mealCount.breakfast,
          lunch_qty: mealCount.lunch,
          dinner_qty: mealCount.dinner,
        },

        meal_price: mealTotal * nights,

      };

      console.log("accessToken : ", accessToken)
      console.log("bookingData : ", bookingData)
      const res = await api.post('/admin/bookings/hotel-room', bookingData, {
        headers: {
          "Content-Type": "application/json",
          "X-ADMIN-TOKEN": `${accessToken}`
        }
      });


      console.log("Booking response:", res.data);
      if (res.data.status === true) {
        setBookingID(res?.data?.data?.id);
        navigate(`/hotel/reviewbooking/${res?.data?.data?.id}`, { state: { bookingDetails: res?.data?.data, hotel: hotelDetails, Time: bookingData, FinalPrice: roomTotalPrice, MealCount: mealCount, MealPrice: mealTotal, NightCount: nights, RoomCount: roomsCount } });

      } else {
        console.log("the error message: ", res.data)
        alert(res.message || "Booking failed. Please try again.");
        return;

      }


    } catch (err) {
      console.log("the error message: ", err?.response?.data?.message);
      showToast(err?.response?.data?.message, "warning")
    }


  }

  const scrollRooms = () => {
   
      roomsRef.current.scrollIntoView({ 
        top:0,
        behavior: 'smooth' });
  }
  const availability = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.", "warning");
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.", "warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests) {
      showToast(`The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`, "warning");
      return;
    }
    try {
      console.log("accessToken:", accessToken);
      if (!accessToken) {
        showToast("Please log in to book a room.", "warning");
        navigate("/signup");
        return;
      }

      const bookingData = {
        hotel_id: id,
        // room_id: selectedRoom.id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),

      };
      if (bookingData.check_in >= bookingData.check_out) {
        showToast("Please give right Date and Time...", "warning");
        return
      }
      console.log("accessToken : ", accessToken)
      console.log("bookingData : ", bookingData)
      setLoading(true);
      const res = await api.post('/check-room-availability', bookingData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      });


      console.log("Booking availability response:", res.data);

      if (res.data.status === true) {
        if (Array.isArray(availableRoom) && availableRoom.length > 0) {
          showToast(`${availableRoom.length} Types of room are available...`, "success");
        }
        setAvailableRoom(res?.data?.data);
        setLoading(false);
        scrollRooms();

        // setBookingID(res?.data?.data?.id);
        // navigate(`/hotel/reviewbooking/${res?.data?.data?.id}`, { state: { bookingDetails: res?.data?.data } });



      } else {
        alert(res.data.message || "Booking failed. Please try again.");
        return;

      }


    } catch (err) {
      console.log(err);
    }


  }
  const availability1 = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.", "error");
      scrollInput();
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.", "warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests) {
      showToast(`The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`, "warning");
      return;
    }
    try {
      console.log("accessToken:", accessToken);
      if (!accessToken) {
        showToast("Please log in to book a room.", "warning");
        navigate("/signup");
        return;
      }

      const bookingData = {
        hotel_id: id,
        // room_id: selectedRoom.id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),

      };
      if (bookingData.check_in >= bookingData.check_out) {
        showToast("Please give right Date and Time...", "warning");
        return
      }
      console.log("accessToken : ", accessToken)
      console.log("bookingData : ", bookingData)
      setLoading(true);
      const res = await api.post('/check-room-availability', bookingData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      });


      console.log("Booking availability response:", res.data);
      if (res.data.status === true) {
        if (Array.isArray(availableRoom) && availableRoom.length > 0) {
          showToast(`${availableRoom.length} Types of room are available...`, "success");
        }
        setAvailableRoom(res?.data?.data);
        setLoading(false);
        // setBookingID(res?.data?.data?.id);
        // navigate(`/hotel/reviewbooking/${res?.data?.data?.id}`, { state: { bookingDetails: res?.data?.data } });



      } else {
        alert(res.data.message || "Booking failed. Please try again.");
        return;

      }


    } catch (err) {
      console.log(err);
    }


  }

  console.log(hotelDetails?.images)


  const [currentSlide, setCurrentSlide] = useState(0);

  // 2️⃣ references for the DOM
  const trackRef = React.useRef(null);
  useEffect(() => {
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${currentSlide * 100}%)`;
    }
  }, [currentSlide]);

  // Autoplay carousel
  useEffect(() => {
    if (!hotelDetails?.images) return;
    const interval = setInterval(() => {
      setCurrentSlide((s) => (s + 1) % hotelDetails.images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [hotelDetails]);


  const totalRatings = hotelreviews.reduce((sum, r) => sum + Number(r.rating || 0), 0);
  const averageRating = hotelreviews.length > 0 ? (totalRatings / hotelreviews.length).toFixed(1) : "No ratings yet";

  const RatingsText = (averageRating) => {
    if (averageRating >= 0 && averageRating < 1) {
      return <span>Pore</span>;
    }
    else if (averageRating >= 1 && averageRating < 2) {
      return <span>Average</span>;
    }
    else if (averageRating >= 2 && averageRating < 3) {
      return <span>Good</span>;
    }
    else if (averageRating >= 3 && averageRating < 4) {
      return <span>Very Good</span>;
    }
    else if (averageRating >= 4 && averageRating <= 5) {
      return <span>Excellent</span>;
    }
    else {
      return <span>No ratings yet</span>;
    }
  }




  // Converts a JS Date to a local datetime string (YYYY-MM-DDTHH:mm)
  const formatDateTimeLocal = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const offset = d.getTimezoneOffset();
    const local = new Date(d.getTime() - offset * 60 * 1000);
    return local.toISOString().slice(0, 16);
  };


  const handleOpenGallery = (item) => {

    const Images = [item, ...hotelDetails?.gallery_images];

    setCurrentImages(Images);
    setLightboxOpen(true);



  };
  const handleOpenGallery1 = (item) => {



    // Extract only URLs
    const imageList = item.images?.map(img => img.image);


    // console.log("the images src are",images)

    setCurrentImages(imageList);
    setLightboxOpen(true);



  };


  const mealPrices = {
    breakfast: selectedRoom?.breakfast === 1 ? selectedRoom.breakfast_price : 0,
    lunch: selectedRoom?.lunch === 1 ? selectedRoom.lunch_price : 0,
    dinner: selectedRoom?.dinner === 1 ? selectedRoom.dinner_price : 0,
  };


  const updateMealCount = (meal, type) => {
    setMealCount(prev => {
      const value =
        type === "inc"
          ? prev[meal] + 1
          : Math.max(0, prev[meal] - 1);

      return { ...prev, [meal]: value };
    });
  };


  const mealTotal =
    mealCount.breakfast * mealPrices.breakfast +
    mealCount.lunch * mealPrices.lunch +
    mealCount.dinner * mealPrices.dinner;


  const roomTotalPrice = totalPrice;
  const mealTotalWithRooms = mealTotal;

  const finalPriceWithMeals = roomTotalPrice;



const applyStaticTime = (dateValue, timeStr) => {
  if (!dateValue || !timeStr) return null;

  const [hour, minute] = timeStr.split(":").map(Number);

  return dayjs(dateValue)
    .hour(hour)
    .minute(minute)
    .second(0)
    .toDate();
};







  return (
    <div>

      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>
      <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />

      <div className="hotelDetail-container" >
        <div className="hotelDetail-grid" style={{ backgroundColor: "#F9F6F1" }}>
          {/* Left Section */}
          <div className="hotelDetail-left animate-fadeIn">
            <div>
              {
                hotelDetails?.gallery_images.length >= 1 &&
                <Carousel fade interval={2000} pause="hover" indicators={true}>
                  {
                    hotelDetails?.gallery_images?.map((photo, index) => (
                      <Carousel.Item key={index}>
                        <img
                          src={photo}
                          alt={`Hotel ${index + 1}`}
                          className="d-block w-100 hotelDetail-image"
                          onClick={() => handleOpenGallery(photo)}
                        />
                      </Carousel.Item>
                    ))}
                </Carousel>
              }

              {hotelDetails?.gallery_images.length < 1 && <img src={noimg} alt='hotel' className="d-block w-100 hotelDetail-image" />}
              <h1 className="hotelDetail-title">{hotelDetails?.name}</h1>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", color: "green", fontWeight: "600" }}>
                <span>Start Check in : {formatTime(hotelDetails?.check_in_time)}</span>
                <span>Last Check out : {formatTime(hotelDetails?.check_out_time)} </span>
              </div>

            </div>

            <p
              className={`hotelDetail-description ${expanded ? "expanded" : ""
                }`}
            >
              <SafeComponent
                html={hotelDetails?.description || "No description available."}
                style={{ margin: "0px" }}
              />
            </p>

            {hotelDetails?.description && (
              <span
                className="show-more-btn1"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? "Show less" : "Show more..."}
              </span>
            )}

            {/* Tags */}
            {/* Amenities */}
            <div className="hotelDetail-tags">
              {aminities.map((amenity, index) => (
                <span className="hotelDetail-tag animate-bounce" key={index}>{amenity?.name}</span>

              ))}

            </div>

            {/* Images */}
            <div ref={roomsRef}>
              <h2 className="hotelDetail-amenitiesTitle">Choose Your best luxury</h2>
              <div className="hotelDetail-amenitiesList">

                {hotelRooms?.map((room) => {
                  const availability = availableRoom.find(a => a.room_id === room.id);

                  return (
                    <div
                      key={room.id}
                      className={`jr-room-card ${selectedRoom?.id === room.id ? "jr-room-card--active" : ""
                        }`}
                      onClick={() => setSelectedRoom(room)}
                    >
                      {/* Image */}
                      <div className="jr-room-image" onClick={() => handleOpenGallery1(room)}>
                        <img
                          src={room?.images?.[0]?.image || "/placeholder-room.jpg"}
                          alt={room?.name}
                        />
                        {availability?.available_rooms === 0 && (
                          <span className="jr-room-badge">Sold Out</span>
                        )}
                        <span className='button_show'>show Images</span>
                      </div>

                      {/* Details */}
                      <div className="jr-room-info">
                        <h4 className="jr-room-title">{room?.name}</h4>

                        <p className="jr-room-meta">
                          👥 Max Guests: {room?.max_guests} &nbsp;|&nbsp;
                          🛏 {room?.room_type}
                        </p>

                        <p className="jr-room-food">
                          🍽️ Available Food:
                          {room.breakfast ? " Breakfast" : ""}
                          {room.lunch ? " Lunch" : ""}
                          {room.dinner ? " Dinner" : ""}
                          {!room.breakfast && !room.lunch && !room.dinner && " No Meals"}
                        </p>
                      </div>

                      {/* Price & Availability */}
                      <div className="jr-room-price">
                        <button className='check_availability_button' onClick={availability1}>Check Availability</button>
                        <span className="jr-room-amount">₹{room?.price_per_night}</span>
                        <span className="jr-room-night">per night</span>

                        {availability && (
                          availability.available_rooms > 0 ? (
                            <span className="jr-room-available">
                              {availability.available_rooms} Rooms Available
                            </span>
                          ) : (
                            <span className="jr-room-soldout-text">Sold Out</span>
                          )
                        )}
                      </div>
                    </div>
                  );
                })}



              </div>
              {loading && <FullScreenSpin />}

            </div>
          </div>

          {/* Right Section */}
          <div className="hotelDetail-right animate-fadeIn">
            {/* Booking Box */}
            <div className="hotelDetail-bookingBox animate-slideInRight">
              <h3 className="hotelDetail-bookingTitle">Join Cottage</h3>
              {hotelRooms?.filter(a => a.id === selectedRoom.id).map((room) => (
                <>
                  <p className="hotelDetail-bookingSub" style={{ marginTop: 0, fontWeight: "600" }}>Maximum Guest Per {room.room_type} room: {room?.max_guests}</p>
                  <p className="hotelDetail-bookingSub" style={{ marginTop: 0, fontWeight: "600" }}>Total {room.room_type} rooms: {room?.no_of_rooms}</p>
                  <p className="hotelDetail-bookingSub" style={{ marginTop: "1rem", fontWeight: "600" }}>Selected room: {room.room_type}</p>

                </>
              ))}


              {/* <p className="hotelDetail-price">
                  ₹{totalPrice}/room
                 
                </p> */}
              <p className="hotelDetail-price"> ₹{roomTotalPrice} ({roomsCount} room{roomsCount > 1 ? "s" : ""})/per day</p>






              <div className="hotelDetail-dateInputs" ref={InputDiv}>
                {/* Room Type */}
                {/* <select className="hotelDetail-selectRoomType" onChange={handleRoomChange} required>
                  {hotelRooms.map((room) => (
                    <option key={room.id} value={room.id}>
                      {room.room_type}
                    </option>
                  ))}
                </select> */}


                <div className="guest-select-wrapper">
                  {/* Adults */}
                  <select
                    className="hotelDetail-selectRoomType"
                    onChange={(e) => setAdults(Number(e.target.value))}
                    required
                  >
                    <option value="1">Select Adult</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </select>
                  {/* Children */}
                  <select
                    className="hotelDetail-selectRoomType"
                    onChange={(e) => setChildren(Number(e.target.value))}
                    required
                  >
                    <option value="0">Select Child</option>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </select>


                </div>

                {/* meal input container */}

                {showMealModal && (
                  <div className="meal-modal-backdrop">
                    <div className="meal-modal">
                      <h3>Add Meals/Day</h3>

                      {/* BREAKFAST */}
                      {mealPrices.breakfast > 0 && (
                        <div className="meal-row">
                          <span>🍳 Breakfast (₹{mealPrices.breakfast})</span>
                          <div className="counter">
                            <button onClick={() => updateMealCount("breakfast", "dec")}>−</button>
                            <span>{mealCount.breakfast}</span>
                            <button onClick={() => updateMealCount("breakfast", "inc")}>+</button>
                          </div>
                        </div>
                      )}

                      {/* LUNCH */}
                      {mealPrices.lunch > 0 && (
                        <div className="meal-row">
                          <span>🍛 Lunch (₹{mealPrices.lunch})</span>
                          <div className="counter">
                            <button onClick={() => updateMealCount("lunch", "dec")}>−</button>
                            <span>{mealCount.lunch}</span>
                            <button onClick={() => updateMealCount("lunch", "inc")}>+</button>
                          </div>
                        </div>
                      )}

                      {/* DINNER */}
                      {mealPrices.dinner > 0 && (
                        <div className="meal-row">
                          <span>🍽️ Dinner (₹{mealPrices.dinner})</span>
                          <div className="counter">
                            <button onClick={() => updateMealCount("dinner", "dec")}>−</button>
                            <span>{mealCount.dinner}</span>
                            <button onClick={() => updateMealCount("dinner", "inc")}>+</button>
                          </div>
                        </div>
                      )}

                      <hr />

                      <p><strong>Meal Total:</strong> ₹{mealTotal}</p>
                      {/* <p><strong>Final Price:</strong> ₹{finalPriceWithMeals}</p> */}

                      <div className="modal-actions">
                        <button onClick={() => setShowMealModal(false)}>Cancel</button>
                        <button onClick={() => setShowMealModal(false)}>Apply for all Days</button>
                      </div>
                    </div>
                  </div>
                )}


                <div className="room-meal-row">
                  {/* ROOMS INPUT */}
                  <div className="room-input-wrapper">
                    <label className="room-label">Rooms</label>
                    <input
                      type="number"
                      min={1}
                      max={maxRooms}
                      value={roomsCount}
                      onChange={(e) => {
                        const value = Math.max(1, Number(e.target.value));
                        if (value > maxRooms) {
                          showToast(`Only ${maxRooms} rooms available`, "warning");
                          return;
                        }
                        setRoomsCount(value);
                      }}
                      className="room-input"
                    />
                  </div>

                  {/* ADD MEALS BUTTON */}
                  <button
                    onClick={() => setShowMealModal(true)}
                    className="add-meals-btn"
                  >
                    Add Meals 🍽️(₹ {mealTotal || 0})
                  </button>
                </div>









<LocalizationProvider dateAdapter={AdapterDayjs}>

  {/* CHECK-IN */}
  <DatePicker
    label="Check-in Date"
    value={checkIn ? dayjs(checkIn) : null}
    minDate={dayjs()}
    format="DD/MM/YYYY"
    onChange={(value) => {
      if (!value) return;

      const checkInWithTime = applyStaticTime(
        value,
        hotelDetails?.check_in_time || "12:00"
      );

      setCheckIn(checkInWithTime);
      setCheckOut(null);
    }}
    slotProps={{
      textField: {
        fullWidth: true,
        required: true,
        size: "small",
      },
    }}
  />

  {/* CHECK-OUT */}
  <DatePicker
    label="Check-out Date"
    value={checkOut ? dayjs(checkOut) : null}
    minDate={checkIn ? dayjs(checkIn).add(1, "day") : dayjs()}
    format="DD/MM/YYYY"
    disabled={!checkIn}
    onChange={(value) => {
      if (!value) return;

      const checkOutWithTime = applyStaticTime(
        value,
        hotelDetails?.check_out_time || "10:00"
      );

      setCheckOut(checkOutWithTime);
    }}
    slotProps={{
      textField: {
        fullWidth: true,
        required: true,
        size: "small",
      },
    }}
  />

</LocalizationProvider>



              </div>






              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                <button className="hotelDetail-bookBtn" onClick={BookNow}>Book Now</button>
                <button className="hotelDetail-bookBtn" onClick={availability} style={{ backgroundColor: "green" }}>Check availability</button>
              </div>

              {/* <p className="hotelDetail-moreOptions">8 more options</p> */}
            </div>

            {/* Review Box */}
            <div className="hotelDetail-reviewBox animate-slideInUp">
              <div className="hotelDetail-reviewHeader">
                <span className="hotelDetail-reviewScore">{totalRatings ? (totalRatings / (hotelreviews.length)).toFixed(1) : "0"}★</span>
                <span className="hotelDetail-reviewText">{RatingsText(averageRating)}</span>
                <span className="hotelDetail-reviewCount">({hotelreviews.length} Reviews)</span>
              </div>

              <div className="hotelDetail-reviewLocation">
                <p className="hotelDetail-locationSub" style={{ marginTop: "3px" }}>{hotelDetails?.land_mark}</p>

                <MapWrapper mapHtml={hotelDetails?.map} height="200px" width="100%" />



              </div>

              <div className="hotelDetail-dealBox">
                <span className="hotelDetail-dealTitle">Last Minute deal</span>
                <p className="hotelDetail-dealText">
                  Congrats! You are getting a discount of ₹826 as a Last Minute
                  Deal offered by the property. Limited time offer only!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  )
}

export default HotelDetails